import { useState, useEffect } from 'react';

import {
  Avatar,
  Button,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { userActions } from 'store/modules/user/user-slice';
import { generateAvatar } from 'utils/avatarHelper';

function UserProfileMd() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userProfile = useSelector((state) => state.user.userProfile);

  const [avatarDataUri, setAvatarDataUri] = useState('');

  // Generate avatar when user profile data is available
  useEffect(() => {
    if (userProfile.data && userProfile.data.characterJson) {
      const characterData = JSON.parse(userProfile.data.characterJson);
      const generatedAvatar = generateAvatar(characterData);
      setAvatarDataUri(generatedAvatar);
    }
  }, [userProfile.data]);

  const handleToggleUserProfileModal = (isOpen) => {
    dispatch(userActions.setUserProfile({ modal: isOpen }));
  };

  const handleEditAvatar = () => {
    dispatch(userActions.setUserProfile({ modal: false }));
    navigate('/me/profile');
  };

  return (
    <Modal
      isOpen={userProfile.modal}
      onClose={() => handleToggleUserProfileModal(false)}
      size="2xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>User Profile</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex gap={4}>
            <Flex
              direction="column"
              gap={2}
              justifyContent="center"
              align="center"
            >
              <Avatar
                src={avatarDataUri}
                name={userProfile.data?.name
                  .replace(/\s*\([^)]*\)\s*$/, '')
                  .trim()}
                fontSize="200px"
                size="full"
                boxSize="200px"
              />
              <Text>{userProfile.data?.name}</Text>
              <Text fontSize="xs" color="gray.500">
                {userProfile.data?.email}
              </Text>
            </Flex>
            <Flex>
              <Divider
                orientation="vertical"
                variant="solid"
                colorScheme="gray"
              />
            </Flex>
            <Flex flex="1" direction="column" gap={3}>
              <FormControl>
                <FormLabel>Gamer Tag #</FormLabel>
                <Input value={userProfile.data?.gamerTag} isReadOnly />
              </FormControl>
            </Flex>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="gray"
            mr={3}
            onClick={() => handleToggleUserProfileModal(false)}
          >
            Close
          </Button>
          <Button colorScheme="red" px={10} onClick={() => handleEditAvatar()}>
            Edit Profile
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default UserProfileMd;
